import React from 'react';
import styled from 'styled-components';

import TappableCard from '../../components/common/TappableCard';
import Header from '../../components/common/Header';
import { Text } from '../../components/common/Text';

import breakfastIcon from '../../images/meal-log/breakfast.svg';
import morningsnacksIcon from '../../images/meal-log/morningsnacks.svg';
import lunchIcon from '../../images/meal-log/lunch.svg';
import eveningsnacksIcon from '../../images/meal-log/eveningsnacks.svg';
import dinnerIcon from '../../images/meal-log/dinner.svg';
import { fontSize } from '../../utils';
import { isMobile } from '../../utils/device';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background: #ffffff;
  padding-top: 0px;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 350px;
  -webkit-overflow-scrolling: touch;
  padding: 0px 16px;
  padding-bottom: ${(props) => (props.$pwa ? '100px' : '80px')};
`;

const TitleText = styled.div`
  font-size: 16px;
  background: white;
  height: 10%;
  border-bottom: 1px solid #f3f3f3;
  padding-left: 16px;
`;

const StyledTappableCard = styled.div`
  flex-direction: row;
  align-items: center;
  padding: 16px 12px;
  border-bottom: 1px solid #f3f3f3;
  height: 60px;
  cursor: pointer;
  &:hover {
    background: #fcfcfc;
  }
  &:active {
    background: #fafafa;
  }
`;

const MealIcon = styled.img`
  width: 20px;
  height: 28px;
  margin-right: 14px;
`;

const MealText = styled(Text)`
  font-size: 14px;
`;

const MealSelectContainer = (props) => {
  const selectMeal = (mealType) => {
    props.history.push('/logmeal/log', {
      mealType,
      dayTimestamp: props.selectedDateTimestamp,
      selectedDate: props.selectedDate,
      dateString: props.dateString,
      fromPage: props.fromPage,
    });
  };
  return (
    <OuterContainer>
      <TitleText className="sticky top-0 bg-white px-2 py-4">
        Add a meal to:
      </TitleText>
      <BodyContainer $pwa={!isMobile()}>
        <StyledTappableCard onClick={() => selectMeal('Early Morning')}>
          {/* <MealIcon src={breakfastIcon} /> */}
          <MealText>Early Morning</MealText>
        </StyledTappableCard>
        <StyledTappableCard onClick={() => selectMeal('Breakfast')}>
          {/* <MealIcon src={breakfastIcon} /> */}
          <MealText>Breakfast</MealText>
        </StyledTappableCard>
        <StyledTappableCard onClick={() => selectMeal('Morning Snacks')}>
          {/* <MealIcon src={morningsnacksIcon} /> */}
          <MealText>Morning Snacks</MealText>
        </StyledTappableCard>
        <StyledTappableCard onClick={() => selectMeal('Lunch')}>
          {/* <MealIcon src={lunchIcon} /> */}
          <MealText>Lunch</MealText>
        </StyledTappableCard>
        <StyledTappableCard onClick={() => selectMeal('Post Lunch')}>
          {/* <MealIcon src={lunchIcon} /> */}
          <MealText>Post Lunch</MealText>
        </StyledTappableCard>
        <StyledTappableCard onClick={() => selectMeal('Evening Snacks')}>
          {/* <MealIcon src={eveningsnacksIcon} /> */}
          <MealText>Evening Snacks</MealText>
        </StyledTappableCard>
        <StyledTappableCard onClick={() => selectMeal('Dinner')}>
          {/* <MealIcon src={dinnerIcon} /> */}
          <MealText>Dinner</MealText>
        </StyledTappableCard>
        <StyledTappableCard onClick={() => selectMeal('Post Dinner')}>
          {/* <MealIcon src={dinnerIcon} /> */}
          <MealText>Post Dinner</MealText>
        </StyledTappableCard>
      </BodyContainer>
    </OuterContainer>
  );
};

export default MealSelectContainer;
